"use client";

import type { PostHog } from "posthog-js";
import type * as SentryBrowser from "@sentry/nextjs";

// The PostHog and Sentry browser SDKs are downloaded only after analytics
// consent (see OptionalTracking) and registered here. Shared code reads them
// through these getters, so neither SDK enters the eagerly loaded bundle.
let posthogClient: PostHog | null = null;
let sentryClient: typeof SentryBrowser | null = null;

export const registerPostHog = (client: PostHog | null) => {
  posthogClient = client;
};

export const getPostHog = () => posthogClient;

export const registerSentry = (client: typeof SentryBrowser | null) => {
  sentryClient = client;
};

export const getSentry = () => sentryClient;
